import type { Component } from 'vue';

export const getViewByAlias = (alias: string): Component | null => {
  switch (alias) {
    case 'AboutUsPage': {
      return defineAsyncComponent(
        async () => import('@/components/views/AboutUsPage.vue') as Promise<Component>
      ) as Component;
    }
    case 'JobOverviewPage': {
      return defineAsyncComponent(
        async () => import('@/components/views/JobOverviewPage.vue') as Promise<Component>
      ) as Component;
    }
    case 'JobPage': {
      return defineAsyncComponent(
        async () => import('@/components/views/JobPage.vue') as Promise<Component>
      ) as Component;
    }
    case 'OurPeoplePage': {
      return defineAsyncComponent(
        async () => import('@/components/views/OurPeoplePage.vue') as Promise<Component>
      ) as Component;
    }
    case 'StatusCodePage': {
      return defineAsyncComponent(
        async () => import('@/components/views/StatusCodePage.vue') as Promise<Component>
      ) as Component;
    }
    case 'WerkenbijContentPage': {
      return defineAsyncComponent(
        async () => import('@/components/views/ContentPage.vue') as Promise<Component>
      ) as Component;
    }
    case 'WerkenbijHomePage': {
      return defineAsyncComponent(
        async () => import('@/components/views/HomePage.vue') as Promise<Component>
      ) as Component;
    }
    default:
      return null;
  }
};
